import artifact from '$houdini/artifacts/CreateVendor'
import { MutationStore } from '../runtime/stores/mutation'

export class CreateVendorStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
